export default __webpack_public_path__ + "static/media/JordiFiguerasResume.e7203da5.pdf";